import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=4c51a754&scoped=true&"
import script from "./VButton.vue?vue&type=script&lang=ts&"
export * from "./VButton.vue?vue&type=script&lang=ts&"
import style0 from "./VButton.vue?vue&type=style&index=0&id=4c51a754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51a754",
  null
  
)

export default component.exports